module.exports = __webpack_public_path__ + "img/about-us-brand-logo.ce398dd1.png";